import { TicketStatus } from './Ticket';

export interface Stat {
  status: TicketStatus;
  _count: {
    status: number;
  };
}

export enum DateRange {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}
